/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Requirements_Required_LaterInputs */

const en_case_requirements_required_later = /** @type {(inputs: Case_Requirements_Required_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required later`)
};

const pt_br2_case_requirements_required_later = /** @type {(inputs: Case_Requirements_Required_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necessário depois`)
};

/**
* | output |
* | --- |
* | "Required later" |
*
* @param {Case_Requirements_Required_LaterInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_requirements_required_later = /** @type {((inputs?: Case_Requirements_Required_LaterInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Requirements_Required_LaterInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_requirements_required_later(inputs)
	return pt_br2_case_requirements_required_later(inputs)
});